module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "full"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/fvii.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "epub:type": "frontmatter",
      "id": "rcover"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062796776_Cover#cover"
    }
  }, [_c('i', [_vm._v("Cover")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "frontmatter",
      "id": "rtit"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062796776_Titlepage#tit"
    }
  }, [_c('i', [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "frontmatter",
      "id": "rded"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062796776_Dedication#ded"
    }
  }, [_c('i', [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('a', {
    attrs: {
      "hidden": "hidden",
      "href": "#/text/9780062796776_Contents"
    }
  }, [_c('span', {
    staticClass: "hide"
  }, [_c('i', [_vm._v("Contents")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "epub:type": "frontmatter",
      "id": "rint"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062796776_Introduction#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Malala Yousafzai")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amelia Earhart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maya Angelou")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nellie Bly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Billie Jean King")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Virginia Woolf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ida B. Wells")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anne Frank")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frida Kahlo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grace Lee Boggs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Emily Dickinson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ellen DeGeneres")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chimamanda Ngozi Adichie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Iris Apfel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sojourner Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grace Hopper")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dolores Huerta")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Helen Keller")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Audre Lorde")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yoko Ono")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_42#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jane Goodall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_44#ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mia Hamm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_45#ch45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Emmeline Pankhurst")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_48#ch48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Janet Mock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_50#ch50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marie Curie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_51#ch51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Julia Child")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_54#ch54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Michelle Obama")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_55#ch55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clara Barton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_57#ch57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marlene Dietrich")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_59#ch59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shirley Chisholm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_62#ch62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miles Franklin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_64#ch64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Misty Copeland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_65#ch65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eleanor Roosevelt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_67#ch67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mae Jemison")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_69#ch69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nora Ephron")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_72#ch72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harriet Tubman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_73#ch73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patti Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_76#ch76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patsy Mink")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_78#ch78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rachel Carson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_80#ch80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ruth Bader Ginsburg")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_81#ch81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oprah Winfrey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_84#ch84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simone de Beauvoir")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_85#ch85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sophie Scholl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_88#ch88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wilma Mankiller")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_90#ch90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grace Jones")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch91"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_91#ch91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yayoi Kusama")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch93"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_93#ch93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zaha Hadid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch96"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_96#ch96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jane Addams")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch98"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_98#ch98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gloria Steinem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch99"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_99#ch99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coretta Scott King")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "chapter",
      "id": "rch101"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Chapter_101#ch101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Influential Woman from Your Own Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "epub:type": "backmatter",
      "id": "rack1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Acknowledgements#ack1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "backmatter",
      "id": "rata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#ata",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "frontmatter",
      "id": "rcop"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062796776_Copyright#cop",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Copyright")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "epub:type": "backmatter",
      "id": "ratp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#atp",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Publisher")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0986ce5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062796776_Contents.vue
// module id = 66
// module chunks = 0